import React from 'react'
import users from '../users.js'
import { Link } from 'react-router-dom'
const Header = ({isTransparent}) => {
    const [ativo, setAtivo] = React.useState(false);
    const marcio = users[0]
    return (
        <>
            <header className={`header ${isTransparent ? 'header--transparent':''}`}>
                <div className="header__menu">
                    <button className="toggler" onClick={()=>{
                        if(ativo){
                            setAtivo(false)
                        }else{
                            setAtivo(true)
                        }
                    }
                    }>
                        <i className="fa fa-bars"></i>  
                    </button>
                </div>
                <div className="header__greeting">
                    Olá, <strong>{marcio.nome}</strong>
                </div>
                {
                    !isTransparent ? '' : <div className="header__return">
                        <Link to="/home">
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                    </div>
                }

            </header>
            <div className={`menu ${ativo ? 'activeMenu' : '' }`}>
                <div className="menu__user">
                    <div className="menu__user__infos">
                        <img src={marcio.userImg} alt={marcio.nome} />
                        <div>
                            <h1>{marcio.nome}</h1>
                            <p>{marcio.email}</p>
                        </div>
                    </div>
                    <button className="toggler" onClick={()=>{
                        if(ativo){
                            setAtivo(false)
                        }else{
                            setAtivo(true)
                        }
                    }
                    }>
                        <i className="fa fa-bars"></i>  
                    </button>
                </div>
                <nav className="menu__navigation">
                    <ul>
                        <li>
                            <Link to="/perfil">
                                <i className="fa fa-user" aria-hidden="true"></i> Perfil                        
                            </Link>
                        </li>
                        <li><i className="fa fa-cog" aria-hidden="true"></i> Configurações</li>
                        <li><i className="fa fa-bell" aria-hidden="true"></i>Notificações</li>
                        <li><i className="fa fa-users" aria-hidden="true"></i> Amigos</li>
                        <li>
                            <Link to="/login">
                                <i className="fa fa-sign-out" aria-hidden="true"></i> Sair
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    )
}

export default Header
